module.exports = __webpack_public_path__ + "img/sec2_3_m.414d9953.png";